import React, { Component } from 'react'
import { Router, Route, IndexRoute, browserHistory, Redirect, IndexRedirect } from 'react-router'
import { App, Signup, ForgotPassword, SetNewPassword,
  UserNav, Cart, BackInStock, Wishlist, Contact, History, Home, HomeProducts,
  Payment, PriceTable, Products, ProductDetail, Profile, Info,

  AdminNav, AdminCompanies,
  AdminCustomers, AdminCustomer,
  AdminGiveaways,
  AdminPromocodes, AdminPromocode,
  // AdminRewards, AdminReward,
  AdminOrders, AdminPayment, AdminProducts, AdminProduct, AdminSetting
} from 'containers'

class Routes extends Component {
  render () {
    return (
      <Router onUpdate={() => window.scrollTo(0, 0)} history={browserHistory}>
        <Route component={App}>

          <Route path='signup' component={Signup} />
          <Route path='forgot-password' component={ForgotPassword} />
          <Route path='set-new-password' component={SetNewPassword} />

          <Route component={UserNav}>
            <Route path='/' component={Home} />
            <Route path='home-products/:key' component={HomeProducts} />
            <Route path='cart' component={Cart} />
            <Route path='wishlist' component={Wishlist} />
            <Route path='contact-us' component={Contact} />
            <Route path='payment' component={Payment} />
            <Route path='price-table' component={PriceTable} />
            <Route path='products' component={Products} />
            <Route path='products/:productCode' component={ProductDetail} />
            <Route path='profile' component={Profile}>
              <Route path='info' component={Info} />
              <Route path='history' component={History} />
            </Route>
          </Route>

          <Route path='admin' component={AdminNav}>
            <IndexRedirect to='orders' />
            <Route path='orders' component={AdminOrders} />
            <Route path='companies' component={AdminCompanies} />
            <Route path='customers'>
              <IndexRoute component={AdminCustomers} />
              <Route path=':customerId' component={AdminCustomer} />
            </Route>
            <Route path='giveaways'>
              <IndexRoute component={AdminGiveaways} />
            </Route>
            <Route path='orders' component={AdminOrders} />
            <Route path='payment' component={AdminPayment} />
            <Route path='products'>
              <IndexRoute component={AdminProducts} />
              <Route path=':productCode' component={AdminProduct} />
            </Route>
            <Route path='promocodes'>
              <IndexRoute component={AdminPromocodes} />
              <Route path=':promocode' component={AdminPromocode} />
            </Route>
            <Route path='setting' component={AdminSetting} />
            <Redirect from='/' to='orders' />
          </Route>

        </Route>
        <Redirect from='*' to='/' />
      </Router>
    )
  }
}

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js